/**
 * @generated SignedSource<<631a85b1f2187275b3317e2969b0c9c7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type BlogTreeInitialData_query$data = {
  readonly blogPosts?: {
    readonly nodes: ReadonlyArray<{
      readonly blank: boolean;
      readonly id: string | null;
      readonly links: {
        readonly webui: string | null;
      } | null;
      readonly metadata: {
        readonly createdDate: string | null;
        readonly lastModifiedDate: string | null;
      };
      readonly properties: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly status: string | null;
      readonly title: string | null;
    } | null> | null;
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
    } | null;
  } | null;
  readonly " $fragmentType": "BlogTreeInitialData_query";
};
export type BlogTreeInitialData_query$key = {
  readonly " $data"?: BlogTreeInitialData_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"BlogTreeInitialData_query">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "blogFirst"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "blogOrderBy"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "blogStatuses"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "includeBlogTree"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "spaceKey"
    }
  ],
  "kind": "Fragment",
  "name": "BlogTreeInitialData_query",
  "selections": [
    {
      "condition": "includeBlogTree",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "blogPosts",
          "args": [
            {
              "kind": "Variable",
              "name": "first",
              "variableName": "blogFirst"
            },
            {
              "kind": "Variable",
              "name": "orderby",
              "variableName": "blogOrderBy"
            },
            {
              "kind": "Variable",
              "name": "spaceKey",
              "variableName": "spaceKey"
            },
            {
              "kind": "Variable",
              "name": "status",
              "variableName": "blogStatuses"
            },
            {
              "kind": "Literal",
              "name": "type",
              "value": "blogpost"
            }
          ],
          "concreteType": "PaginatedContentListWithChild",
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": [
            {
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "hasNextPage"
                },
                {
                  "kind": "ScalarField",
                  "name": "endCursor"
                }
              ]
            },
            {
              "concreteType": "Content",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "title"
                },
                {
                  "kind": "ScalarField",
                  "name": "status"
                },
                {
                  "kind": "ScalarField",
                  "name": "blank"
                },
                {
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "keys",
                      "value": [
                        "emoji-title-published",
                        "emoji-title-draft",
                        "editor"
                      ]
                    }
                  ],
                  "concreteType": "PaginatedJsonContentPropertyList",
                  "kind": "LinkedField",
                  "name": "properties",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JsonContentProperty",
                      "kind": "LinkedField",
                      "name": "nodes",
                      "plural": true,
                      "selections": [
                        (v0/*: any*/),
                        {
                          "kind": "ScalarField",
                          "name": "key"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "value"
                        }
                      ]
                    }
                  ],
                  "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"])"
                },
                {
                  "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                  "kind": "LinkedField",
                  "name": "links",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "webui"
                    }
                  ]
                },
                {
                  "concreteType": "ContentMetadata",
                  "kind": "LinkedField",
                  "name": "metadata",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "lastModifiedDate"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "createdDate"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "701bdbd74f1fd5bdaf35a9c0ab32ea3d";

export default node;
